import { createRouter, createWebHashHistory } from 'vue-router'
import AdminDashboard from '../components/Dashboard.vue'
import AdminSettings from '../components/AdminSettings.vue'
import AdminTools from '../components/Tools.vue'
import AdminAutomations from '../components/AdminAutomations.vue'
import GetStarted from '../components/GetStarted.vue'

// Create initial routes with components we know exist
const initialRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    component: AdminDashboard
  },
  {
    path: '/settings',
    name: 'Settings',
    component: AdminSettings
  },
  {
    path: '/tools',
    name: 'Tools',
    component: AdminTools
  },
  {
    path: '/automations',
    name: 'Automations',
    component: AdminAutomations
  },
  {
    path: '/get-started',
    name: 'Get Started',
    component: GetStarted
  }
]

// Create router with hash mode which works better in WordPress admin
const router = createRouter({
  history: createWebHashHistory(),
  routes: initialRoutes
})

// Add dynamic routes from WordPress settings if available
function addDynamicRoutes() {
  if (window.smartpress_vueWpSettings && window.smartpress_vueWpSettings.menuItems) {
    const componentMap = {
      '': AdminDashboard,
      '-settings': AdminSettings,
      '-tools': AdminTools,
      '-automations': AdminAutomations,
    }
    
    // Add routes for each menu item from WordPress
    window.smartpress_vueWpSettings.menuItems.forEach(item => {
      // Check if route already exists
      if (!router.hasRoute(item.title)) {
        router.addRoute({
          path: item.route,
          name: item.title,
          component: componentMap[item.slug] || AdminDashboard
        })
      }
    })
  }
}

// If settings are already available, add routes immediately
if (window.smartpress_vueWpSettings) {
  addDynamicRoutes()
} else {
  // Otherwise wait for settings to be available
  window.addEventListener('smartpress_vueWpSettingsLoaded', addDynamicRoutes)
}

export default router 